export const heroFacts = [
  { label: '出道年份', value: '约 2020 年' },
  { label: '活跃地区', value: '海外平台为主' },
  { label: '内容形态', value: '影像与订阅内容' },
  { label: '公开状态', value: '长期保持匿名' },
];

export const collectionIndex = [
  { no: '01', title: '人物档案', desc: '从网名来源到公众形象的快速速览，一次看懂她是谁。', anchor: 'profile' },
  { no: '02', title: '基本资料', desc: '常用名、活跃年份、平台与内容形式的结构化整理。', anchor: 'profile-table' },
  { no: '03', title: '真实身份', desc: '围绕匿名与身份猜测的几种主流说法与核实提示。', anchor: 'identity' },
  { no: '04', title: '走红脉络', desc: '按时间线梳理从首次出现到成为话题人物的过程。', anchor: 'timeline' },
  { no: '05', title: '出道信息', desc: '出道时间、起点平台与早期内容方向的说明。', anchor: 'timeline' },
  { no: '06', title: '百科词条', desc: '与人物相关的核心词条索引，便于逐条检索。', anchor: 'wiki' },
  { no: '07', title: '常见问答', desc: '整理读者最常提出的若干问题与简要解答。', anchor: 'faq' },
  { no: '08', title: '延伸阅读', desc: '围绕话题的讨论角度与推荐阅读顺序建议。', anchor: 'faq' },
];

export const quickProfile = [
  {
    icon: 'ri-user-star-line',
    title: '网名由来',
    text: '“玩偶姐姐”来自她早期使用的昵称，随着内容传播，逐渐成为大众熟悉的称呼。',
  },
  {
    icon: 'ri-live-line',
    title: '活跃平台',
    text: '主要活跃于海外订阅与内容平台，中文网络里多为二手转述与讨论。',
  },
  {
    icon: 'ri-movie-2-line',
    title: '内容方向',
    text: '以影像内容为主，风格与定位在几年之间有过调整与变化。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '公众形象',
    text: '因长期不公开露面，被外界视为典型的“匿名网红”与话题人物。',
  },
];

export const profileTable = [
  { label: '常用名', value: '玩偶姐姐' },
  { label: '常见别名', value: '网络上另有数种译名与称呼' },
  { label: '活跃年份', value: '约 2020 年起' },
  { label: '内容形式', value: '影像、订阅内容为主' },
  { label: '主要平台', value: '海外订阅类平台' },
  { label: '使用语言', value: '中文为主' },
  { label: '活跃地区', value: '海外，具体位置未公开' },
  { label: '公开状态', value: '长期保持匿名' },
];

export const identityPoints = [
  {
    title: '为何长期匿名',
    text: '她极少公开露面或透露个人背景，公开画面多经过处理，刻意隐藏真实相貌。',
  },
  {
    title: '主流的几种说法',
    text: '外界对其真实身份有不同猜测，但大多缺乏可核实的公开证据，需要谨慎看待。',
  },
  {
    title: '信息核实提示',
    text: '同一说法常被反复转述，容易以讹传讹；建议以公开、可追溯的资料为准。',
  },
];

export const timeline = [
  { time: '约 2020 年', title: '首次出现在海外订阅平台', text: '以“玩偶姐姐”这一昵称开始发布内容，早期关注度相对有限。' },
  { time: '2021 年', title: '关注度快速上升', text: '随着内容被传播，开始在中文网络中被大量讨论与转述。' },
  { time: '2022 年', title: '成为话题人物', text: '关于其真实身份的猜测增多，相关讨论扩散到更多平台。' },
  { time: '2023 年', title: '内容形态调整', text: '在保持匿名形象的同时，内容方向与运营方式有所变化。' },
  { time: '2024 年至今', title: '持续活跃与讨论', text: '依然活跃于海外平台，围绕其真实身份的讨论仍在延续。' },
];

export const wikiEntries = [
  { term: '玩偶姐姐是谁', desc: '对其公众身份的入门式说明。' },
  { term: '个人资料', desc: '汇总可公开的基本信息条目。' },
  { term: '真实身份', desc: '围绕匿名与身份猜测的整理。' },
  { term: '出道信息', desc: '出道时间与起点平台的说明。' },
  { term: '内容风格', desc: '对其作品气质与定位的概括。' },
  { term: '公众形象', desc: '外界对她的整体认知与标签。' },
  { term: '网络讨论', desc: '围绕话题的常见讨论角度。' },
  { term: '延伸词条', desc: '相关人物与概念的扩展阅读。' },
];

export const faqs = [
  { q: '玩偶姐姐是谁？', a: '她是一位长期保持匿名的海外内容创作者，以“玩偶姐姐”这一昵称被中文网络熟知。' },
  { q: '她的真实身份被公开了吗？', a: '截至目前，其真实身份并未被可靠地公开证实，网络上流传的说法大多缺乏可核实的证据。' },
  { q: '她是什么时候出道的？', a: '根据公开可见的痕迹，她大约在 2020 年前后开始活跃于海外订阅平台。' },
  { q: '为什么她一直不露面？', a: '有意隐藏真实相貌是其一贯做法，这既是个人选择，也与其内容定位有关。' },
  { q: '本页信息可以直接引用吗？', a: '本页为公开资料的整理与归纳，仅供了解与参考，重要信息请以权威来源为准。' },
];